<style scoped>
.card {
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  transition: 0.3s;
  width: 100%;
  border-radius: 10px;
}

.disable-address,
.disable-address input[type='radio'] {
}

.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
}

.d-none-width {
  width: 250px;
  max-width: 250px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.d-none-price {
  width: 100px;
}

@media only screen and (max-width: 600px) {
  .d-none-width {
    width: auto;
    max-width: 100%;
  }

  .d-none-price {
    width: auto;
  }

  .mobile-product {
    padding: 20px;
  }
}
</style>

<template>
  <div>
    <main id="content" role="main" class="cart-page" v-loading.fullscreen.lock="fullscreenLoading">
      <div class="container">
        <div class="row my-8">
          <div class="col-2 col-md-3"></div>
          <div class="col-8 col-md-6">
            <div class="order-progress">
              <div>
                <div class="order-progress-first-circe order-progress-active">
                  <img v-if="step == 0" src="@/assets/svg/checkmark.svg" class="check-svg">
                  <div>Сагслах</div>
                </div>
                <div class="order-progress-middle-line" :class="{ 'order-progress-active': step >= 1 }"></div>
                <div class="order-progress-second-circle" :class="{ 'order-progress-active': step >= 1 }">
                  <img v-if="step == 1" src="@/assets/svg/checkmark.svg" class="check-svg">
                  <div>Хаягын мэдээлэл оруулах</div>
                </div>
              </div>
              <div>
                <div class="order-progress-middle-line" :class="{ 'order-progress-active': step >= 2 }"></div>
                <div class="order-progress-third-circle" :class="{ 'order-progress-active': step >= 2 }">
                  <img v-if="step == 2" src="@/assets/svg/checkmark.svg" class="check-svg">
                  <div>Төлбөр төлөх</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-2 col-md-3"></div>
        </div>

        <span style="float: right; margin-right: 20px; font-size: 16px;">
          Миний бонус
          <i class="fas fa-gift" style="font-size: 14px; margin: 0 2px 0 10px;"></i>
          {{ shipping.user.bonus }}
        </span>
        <div style="clear: both;"></div>
      </div>

      <div class="container">
        <form @submit.prevent="submitForm" ref="form" id="form">
          <div class="row">
            <div class="mb-2 cart-table col-md-8 card p-5">
              <div class="row">
                <div class="col-md-6 mt-2">
                  <button
                    type="button"
                    class="btn btn-outline-primary"
                    @click="changePersonal(true)"
                    :class="{ 'btn-primary-dark-w': shipping.user.personal === true }"
                    style="width: 100%; border-radius: 30px; height: 50px;"
                  >
                    <i class="fas fa-user-tie lg pr-1"></i> Хувь хүн
                  </button>
                </div>

                <div class="col-md-6 mt-2">
                  <button
                    type="button"
                    class="btn btn-outline-primary"
                    @click="changePersonal(false)"
                    :class="{ 'btn-primary-dark-w': shipping.user.personal === false }"
                    style="width: 100%; border-radius: 30px; height: 50px;"
                  >
                    <i class="fas fa-store-alt lg pr-1"></i> Албан байгууллага
                  </button>
                </div>
              </div>

              <div class="mt-2" align="left">
                <h5 class="ml-1 font-size-18 font-weight-bold">Холбоо барих</h5>
              </div>

              <div class="row mb-2">
                <div class="col-md-6 mt-2">
                  <label><strong>Нэр <span class="text-danger">*</span></strong></label>
                  <el-input
                    placeholder=""
                    required
                    v-model="shipping.user.name"
                    clearable
                  />
                </div>

                <div class="col-md-6 mt-2">
                  <label><strong>Утасны дугаар <span class="text-danger">*</span></strong></label>
                  <el-input
                    placeholder="STOREPAY ашиглах бол энд дугаараа оруулна уу"
                    required
                    pattern="\d{8}"
                    v-model="shipping.user.phone"
                    clearable
                  />
                </div>

                <div class="col-md-6 mt-2">
                  <label><strong>Имэйл хаяг <span class="text-danger">*</span></strong></label>
                  <el-input
                    placeholder=""
                    required
                    type="email"
                    v-model="shipping.user.email"
                    clearable
                  />
                </div>

                <div v-if="shipping.user.personal === true" class="col-md-6 mt-2">
                  <label><strong>Утасны дугаар 2</strong></label>
                  <el-input
                    placeholder=""
                    pattern="\d{8}"
                    v-model="shipping.user.phone2"
                    clearable
                  />
                </div>

                <div v-else class="col-md-6 mt-2">
                  <label><strong>Байгууллагын регистр <span class="text-danger">*</span></strong></label>
                  <el-input
                    placeholder=""
                    required
                    pattern="\d{7}"
                    v-model="shipping.user.register"
                    clearable
                  />
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 mt-2">
                  <button
                    type="button"
                    class="btn btn-outline-primary"
                    @click="selectDeliver"
                    :class="{ 'btn-primary-dark-w': deliver === true }"
                    style="width: 100%; border-radius: 30px; height: 50px;"
                  >
                    Хүргүүлэх хаяг
                  </button>
                </div>

                <div class="col-md-6 mt-2">
                  <button
                    type="button"
                    class="btn btn-outline-primary"
                    @click="selectWarehouse"
                    :class="{ 'btn-primary-dark-w': warehouse === true }"
                    style="width: 100%; border-radius: 30px; height: 50px;"
                  >
                    Очиж авах хаяг
                  </button>
                </div>
              </div>

              <div class="row mb-2" v-if="deliver">
                <div class="col-md-12"></div>

                <div class="col-md-6 mt-2">
                  <label><strong>Дүүрэг <span class="text-danger">*</span></strong></label>
                  <el-select
                    @change="calculateShipping"
                    v-model="shipping.user.district"
                    filterable
                    placeholder="Дүүрэг"
                    :style="{ width: '100%' }"
                  >
                    <el-option
                      v-for="(item, index) in range.district"
                      :key="index"
                      :label="item.district"
                      :value="item.id"
                    />
                  </el-select>
                </div>

                <div class="col-md-6 mt-2" v-if="shipping.user.district != 7 && shipping.user.district != 9">
                  <label><strong>Хороо <span class="text-danger">*</span></strong></label>
                  <el-select
                    @change="calculateShipping"
                    v-model="shipping.user.khoroo"
                    filterable
                    placeholder="Хороо"
                    :style="{ width: '100%' }"
                  >
                    <el-option
                      v-for="(item, index) in selectKhoroo()"
                      :key="index"
                      :label="item + '-р хороо'"
                      :value="item"
                    />
                  </el-select>
                </div>

                <div class="col-md-12 mt-2">
                  <label><strong>Дэлгэрэнгүй хаяг <span class="text-danger">*</span></strong></label>
                  <el-input
                    required
                    maxlength="100"
                    type="textarea"
                    :autosize="{ minRows: 3, maxRows: 5 }"
                    v-model="shipping.user.more"
                    id="placeholder"
                    clearable
                  />
                </div>

                <div class="col-12 col-md-12" style="display: flex; justify-content: center;">
                  <div class="col-6">
                    <div
                      class="col-12 check2"
                      style="display: flex; align-content: center; align-items: center; padding: 5px 20px; margin: 10px; border: solid 1px #e3e3e3; border-radius: 25px; width: 200px; cursor: pointer;"
                      @click="assemble = !assemble"
                    >
                      <input type="checkbox" v-model="assemble" style="margin: 2px 30px 0 0">
                      <span>Угсралт</span>
                    </div>

                    <div class="input-number2" style="margin-left: 20px;" v-if="assemble">
                      <a href="javascript:;" class="counts2" @click="changeAss(false)">-</a>
                      <input type="number" v-model.number="cart.assemblecount" :min="1" class="product-count">
                      <a href="javascript:;" class="counts2" @click="changeAss(true)">+</a>
                    </div>
                  </div>

                  <div class="col-6">
                    <div
                      class="col-12 check2"
                      style="display: flex; padding: 5px 20px; margin: 10px; border: solid 1px #e3e3e3; border-radius: 25px; width: 200px; cursor: pointer;"
                      @click="mow = !mow"
                    >
                      <input type="checkbox" v-model="mow" style="margin: 2px 30px 0 0">
                      <span>Тогтоолт</span>
                    </div>

                    <div class="input-number2" style="margin-left: 20px;" v-if="mow">
                      <a href="javascript:;" class="counts2" @click="changeMow(false)">-</a>
                      <input type="number" v-model.number="cart.mowcount" :min="1" class="product-count">
                      <a href="javascript:;" class="counts2" @click="changeMow(true)">+</a>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-md-6">
                  <div style="border-radius: 10px; padding: 5px 10px; background-color: #e6e6e6; margin-top: 20px;">
                    <span>Нийт:</span><br>
                    <span>{{ cart.productCount }} бүтээгдэхүүн, {{ cart.packCount }} хайрцаг, {{ cart.totalKg }}кг, {{ cart.totalVol }} volume.</span>
                  </div>
                </div>
              </div>

              <div class="row mt-4" id="disable-address" v-if="warehouse">
                <div class="px-3 py-2" style="border: solid 1px #d0d2d6; border-radius: 5px; margin: 0 15px; width: 100%;">
                  <div>
                    <input type="radio" v-model="shipping.warehouse" @click="deliverFalse" value="1">
                    <span>Баянзүрх дүүрэг, Их наяд худалдааны төв 2 давхарт ITLAB дэлгүүр</span>
                  </div>
                  <div>
                    <input type="radio" v-model="shipping.warehouse" @click="deliverFalse" value="3">
                    БГД 25-р хороо, Хонгор апартмент, М март хаалга, 3 давхар, 304 тоот (Алтай хотхоны урд). Утас: 7511-4532
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-8 cart-total col-md-4" align="center">
              <div class="row card p-5 mb-3">
                <div class="border-bottom border-color-1 mb-3" align="right">
                  <h3 class="d-inline-block mb-0 pb-2 font-size-22">Бүтээгдэхүүн</h3>
                </div>

                <table class="table mb-3 mb-md-0">
                  <tbody>
                    <tr v-for="(item, index) in filteredProducts" :key="index" class="cart-subtotal">
                      <th>{{ item.name }}</th>
                      <td data-title="Subtotal">
                        <span class="amount">{{ item.qty }} X ₮{{ Number(item.price || 0).toLocaleString() }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="row card p-5">
                <div class="col-md-14">
                  <div class="border-bottom border-color-1 mb-3" align="right">
                    <h3 class="d-inline-block mb-0 pb-2 font-size-22">Захиалгын мэдээлэл</h3>
                  </div>

                  <table class="table mb-3 mb-md-0">
                    <tbody>
                      <tr class="cart-subtotal check">
                        <td class="subtotal-items">
                          <input type="checkbox" v-model="checked" disabled>
                          <span>Үнэ</span>
                        </td>
                        <td data-title="Үнэ" style="vertical-align: middle;">
                          <span class="amount">₮{{ Number(cart.subtotal).toLocaleString() }}</span>
                        </td>
                      </tr>

                      <tr class="cart-subtotal check" style="color:#0057AD;" v-if="coupon.active">
                        <td class="subtotal-items">
                          <input type="checkbox" v-model="coupon.active" @click="RemoveCoupon">
                          Ваучер
                        </td>
                        <td data-title="Хөнгөлөлт" style="vertical-align: middle;">
                          <span class="amount">₮{{ Number(parseInt(coupon.amount || 0)).toLocaleString() }}</span>
                        </td>
                      </tr>

                      <tr class="order-total check" v-if="deliver">
                        <td class="subtotal-items">
                          <input type="checkbox" v-model="deliver">
                          Хүргэлт
                        </td>
                        <td style="vertical-align: middle;">₮{{ Number(shipping.amount || 0).toLocaleString() }}</td>
                      </tr>

                      <tr class="order-total check" v-if="deliver && assemble">
                        <td class="subtotal-items">
                          <input type="checkbox" v-model="assemble">
                          Угсралт
                        </td>
                        <td style="vertical-align: middle;">₮{{ Number(cart.assemble || 0).toLocaleString() }}</td>
                      </tr>

                      <tr class="order-total check" v-if="deliver && mow">
                        <td class="subtotal-items">
                          <input type="checkbox" v-model="mow">
                          Тогтоолт
                        </td>
                        <td style="vertical-align: middle;">₮{{ Number(cart.mow || 0).toLocaleString() }}</td>
                      </tr>

                      <tr class="order-total font-size-10 check" v-if="cart.chinaDeliver > 0">
                        <td class="subtotal-items">
                          <input type="checkbox" v-model="checked" disabled>
                          <span>Овор, жингийн нэмэгдэл</span>
                        </td>
                        <td style="vertical-align: middle;">₮{{ Number(cart.chinaDeliver || 0).toLocaleString() }}</td>
                      </tr>

                      <tr class="order-total check">
                        <td class="subtotal-items">
                          <input type="checkbox" v-model="checked" disabled>
                          <span class="font-size-10">Үйлчилгээний хөлс</span>
                        </td>
                        <td style="vertical-align: middle;">₮{{ Number(cart.Fee || 0).toLocaleString() }}</td>
                      </tr>
                    </tbody>
                  </table>

                  <div style="border: solid 1px;"></div>

                  <table class="table mb-3 mb-md-0">
                    <tbody>
                      <tr class="order-total check">
                        <td class="subtotal-items">
                          <input type="checkbox" v-model="NOAT">
                          <span> НӨАТ </span>
                        </td>
                        <td style="vertical-align: middle;">₮{{ Number(cart.NOAT || 0).toLocaleString() }}</td>
                      </tr>
                    </tbody>
                  </table>

                  <div style="display: flex; justify-content: space-between; align-items: center; padding: 0 12px; margin-top: 10px;">
                    <b class="total-amount">Нийт дүн</b>
                    <span class="price font-size-18 font-weight-bold">{{ Number(cart.sum || 0).toLocaleString() }}</span>
                  </div>
                </div>
              </div>

              <div class="row pl-1 pr-1">
                <div class="col-md-12" align="center">
                  <div
                    class="btn btn-primary-orange mt-3"
                    @click="coupontInput"
                    :class="{ 'coupon-add': coupon.input, 'coupon-remove': !coupon.input }"
                    style="width: 100%; border-radius: 12px;"
                  >
                    <span v-if="!coupon.input" style="display: block; margin: 10px;">Ваучер ашиглах</span>
                    <div style="width: 100%;">
                      <input type="text" v-model="coupon.code" placeholder="Ваучер код">
                      <button type="button" v-if="coupon.active" class="coupon-x" @click="RemoveCoupon">X</button>
                      <button type="button" v-if="!coupon.active" class="coupon-plus" @click="useCoupon">Ашиглах</button>
                    </div>
                  </div>

                  <button type="button" @click="submitForm" class="btn btn-primary-dark-w mt-1" style="width: 100%; border-radius: 12px;">
                    Төлбөр
                  </button>

                  <button type="button" @click="backRoute" class="btn btn-outline-primary mt-1" style="width: 100%; border-radius: 12px;">
                    Буцах
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </main>

    <Brands />

    <el-dialog title="Газрын зураг" :visible.sync="dialogMap" :modalAppendToBody="false">
      <Map />
    </el-dialog>
  </div>
</template>

<script>
import Brands from "@/components/brands";
import Map from "@/components/map";

const api = require("@what3words/api");
api.setOptions({ key: "E5XS8ZV3" });

export default {
  components: {
    Brands,
    Map
  },

  data() {
    return {
      checked: true,
      deliver: true,
      assemble: false,
      NOAT: false,
      warehouse: false,
      useBonus: false,
      compRegNOAT: "",
      mow: false,
      map: null,
      dialogMap: false,
      fullscreenLoading: false,
      step: 1,

      cart: {
        product: [],
        real: [],
        totalKg: 0,
        totalVol: 0,
        packCount: 0,
        productCount: 0,
        subtotal: 0,
        sale: 0,
        bonus: 0,
        useBonus: 0,
        bonusLimit: 0,
        assemble: 0,
        assemblecount: 1,
        chinaDeliver: 0,
        Fee: 0,
        mow: 0,
        mowcount: 1,
        NOAT: 0,
        sum: 0
      },

      shipping: {
        warehouse: 0,
        amount: 0,
        user: {
          personal: true,
          district: "",
          khoroo: 1,
          more: "",
          name: "",
          phone: "",
          phone2: "",
          email: "",
          register: "",
          bonus: 0
        },
        w3w: "",
        lat: 47.919143,
        long: 106.917597
      },

      range: {
        district: []
      },

      coupon: {
        code: null,
        active: false,
        amount: 0,
        input: false
      }
    };
  },

  mounted() {
    const placeholder = document.getElementById("placeholder");
    if (placeholder) {
      placeholder.placeholder = "1. Дэлгэрэнгүй хаягаа оруулна уу. \n2. Хэрэв та орон нутгийн хэрэглэгч бол дүүрэг хэсгээс чиглэлийн авто вокзалыг сонгоод Аймаг сумын нэрийг заавал бичнэ.";
    }

    this.$emit("getJquery");
    this.getProduct();
  },

  computed: {
    filteredProducts() {
      return (this.cart.product || []).filter((el) => {
        const isChecked =
          el.checked === true ||
          el.checked === 1 ||
          el.checked === "1" ||
          typeof el.checked === "undefined";


        return isChecked;
      });
    }
  },

  watch: {
    deliver(val) {
      if (!val) {
        this.shipping.amount = 0;
      }
      this.calculate();
    },
    warehouse() {
      this.calculate();
    },
    assemble() {
      this.calculate();
    },
    mow() {
      this.calculate();
    },
    NOAT() {
      this.calculate();
    },
    "cart.assemblecount"() {
      this.calculate();
    },
    "cart.mowcount"() {
      this.calculate();
    },
    "coupon.active"() {
      this.calculate();
    },
    "coupon.amount"() {
      this.calculate();
    }
  },

  methods: {
    checkBonus() {
      const user = JSON.parse(localStorage.getItem("user"));
      return user ? `${Number(user.bonus).toLocaleString()}` : "";
    },

    coupontInput() {
      this.coupon.input = true;
    },

    normalizeCartItem(el) {
      return {
        ...el,
        checked: typeof el.checked === "undefined" ? true : el.checked,
        show_product: typeof el.show_product === "undefined" ? true : el.show_product,
        qty: Number(el.qty) || 1,
        price: Number(el.price) || 0,
        chinaDeliver: Number(el.chinaDeliver) || 0,
        discount: Number(el.discount) || 0,
        bonus: Number(el.bonus) || 0
      };
    },

    isItemSelectable(el) {
      const isChecked =
        el.checked === true ||
        el.checked === 1 ||
        el.checked === "1" ||
        typeof el.checked === "undefined";

      return isChecked;
    },

    getSelectedProducts() {
      return (this.cart.product || []).filter((el) => this.isItemSelectable(el));
    },

    syncExtraServiceAmounts() {
      this.cart.assemble =
        this.deliver && this.assemble
          ? 30000 * (Number(this.cart.assemblecount) || 1)
          : 0;

      this.cart.mow =
        this.deliver && this.mow
          ? 20000 * (Number(this.cart.mowcount) || 1)
          : 0;

      if (!this.deliver) {
        this.shipping.amount = 0;
      }
    },

    selectDeliver() {
      this.deliver = true;
      this.warehouse = false;
      this.shipping.warehouse = 0;
      this.calculateShipping();
      this.calculate();
    },

    selectWarehouse() {
      this.warehouse = true;
      this.deliver = false;

      if (!this.shipping.warehouse) {
        this.shipping.warehouse = 1;
      }

      this.shipping.amount = 0;
      this.calculate();
    },

    deliverFalse() {
      this.deliver = false;
      this.warehouse = true;

      if (this.shipping.warehouse == 0) {
        this.shipping.warehouse = 1;
      }

      this.shipping.amount = 0;
      this.calculate();
    },

    backRoute() {
      this.$router.push("/cart?role=cart");
    },

    getCenter() {
      if (this.map && this.map.getCenter) {
        console.log(this.map.getCenter().toJSON());
      }
    },

    changeAss(val) {
      let count = Number(this.cart.assemblecount) || 1;

      if (val) {
        count++;
      } else {
        count = Math.max(1, count - 1);
      }

      this.cart.assemblecount = count;
      this.calculate();
    },

    changeMow(val) {
      let count = Number(this.cart.mowcount) || 1;

      if (val) {
        count++;
      } else {
        count = Math.max(1, count - 1);
      }

      this.cart.mowcount = count;
      this.calculate();
    },

    calculateBonusLimit() {
      const am = this.cart.subtotal - this.cart.sale - this.coupon.amount;
      const limit = parseInt(am / 2);

      if (limit > this.shipping.user.bonus) {
        this.cart.bonusLimit = this.shipping.user.bonus;
      } else {
        this.cart.bonusLimit = limit;
      }

      localStorage.bonusLimit = this.cart.bonusLimit;

      const b = localStorage.getItem("bonus");
      if (b != null) {
        this.cart.useBonus = b;
      } else {
        this.cart.useBonus = this.cart.bonusLimit;
        localStorage.bonus = this.cart.useBonus;
      }
    },

    getWhat3Words() {
      const rts = this;

      navigator.geolocation.getCurrentPosition(function (params) {
        rts.shipping.lat = params.coords.latitude;
        rts.shipping.long = params.coords.longitude;

        api.convertTo3wa({
          lat: params.coords.latitude,
          lng: params.coords.longitude,
          language: "mn"
        }).then((data) => {
          rts.shipping.w3w = data.words;
          localStorage.w3w = data.words;
        });
      });
    },

    RemoveCoupon() {
      localStorage.removeItem("coupon");
      this.coupon.code = null;
      this.coupon.amount = 0;
      this.coupon.active = false;
      this.calculate();
    },

    useCoupon() {
      const rts = this;
      const token = localStorage.getItem("token");

      rts.$axios({
        method: "POST",
        url: rts.$appUrl + "/api/product/use-coupon",
        headers: {
          Authorization: `Bearer ${token}`
        },
        data: {
          coupon: this.coupon.code
        }
      }).then((data) => {
        if (data.data.result === "failed") {
          rts.$notify({
            title: "Амжилтгүй",
            message: "Купон код буруу эсвэл ашиглагдсан байна",
            type: "error"
          });
        } else {
          const am = this.cart.subtotal - this.cart.sale;

          if (parseInt(am) < data.data.promo[0].amount) {
            rts.coupon.amount = parseInt(am);
            localStorage.coupon = JSON.stringify({
              code: rts.coupon.code,
              amount: parseInt(am)
            });
          } else {
            rts.coupon.amount = data.data.promo[0].amount;
            localStorage.coupon = JSON.stringify({
              code: rts.coupon.code,
              amount: data.data.promo[0].amount
            });
          }

          rts.coupon.active = true;
          this.calculate();

          rts.$notify({
            title: "Амжилттай",
            dangerouslyUseHTMLString: true,
            message: `Үнийн дүнгээс <strong>${rts.coupon.amount}₮</strong> хасагдлаа`,
            type: "success"
          });
        }
      });
    },

    calculateShipping() {
      if (!this.deliver) {
        this.shipping.amount = 0;
        localStorage.shipping = 0;
        this.calculate();
        return;
      }

      const totalVol = Number(this.cart.totalVol) || 0;
      const totalKg = Number(this.cart.totalKg) || 0;
      let weight = totalVol / 3.14 > totalKg ? totalVol / 3.14 : totalKg;
      let amount = 0;

      this.range.district.forEach((element) => {
        if (element.id == this.shipping.user.district) {
          let cheap = [];
          let exp = [];
          let more = [];

          if (element.cheap_khoroo != null) cheap = element.cheap_khoroo.split(",");
          if (element.middle_khoroo != null) exp = element.middle_khoroo.split(",");
          if (element.more_exp != null) more = element.more_exp.split(",");

          if (cheap.includes(String(this.shipping.user.khoroo))) {
            amount = 10000;
            if (weight > 35 && weight < 200) amount += 8000;
            else if (weight > 200) amount += 14000;
          } else if (exp.includes(String(this.shipping.user.khoroo))) {
            amount = 14000;
            if (weight > 35 && weight < 200) amount += 10000;
            else if (weight > 200) amount += 40000;
          } else if (more.includes(String(this.shipping.user.khoroo))) {
            amount = 50000;
            if (weight > 35 && weight < 200) amount += 30000;
            else if (weight > 200) amount += 65000;
          } else {
            amount = 10000;
            if (weight > 35 && weight < 200) amount += 8000;
            else if (weight > 200) amount += 14000;
          }
        }
      });

      this.shipping.amount = amount;
      localStorage.shipping = amount;
      this.calculate();
    },

    selectKhoroo() {
      let khoroo = 0;

      this.range.district.forEach((element) => {
        if (element.id == this.shipping.user.district) {
          khoroo = Number(element.number_of_khoroo) || 0;
        }
      });

      if (!khoroo) return [];
      return Array.from({ length: khoroo }, (_, i) => i + 1);
    },

    changePersonal(value) {
      this.shipping.user.personal = value;
      this.NOAT = !value;
      this.calculate();
    },

    calculate() {
      let subtotal = 0;
      let sale = 0;
      let bonus = 0;
      let fee = 0;
      let chinaDeliver = 0;

      const selectedProducts = this.getSelectedProducts();

      selectedProducts.forEach((element) => {
        const qty = Number(element.qty) || 0;
        const price = Number(element.price) || 0;
        const discount = Number(element.discount) || 0;
        const productBonus = Number(element.bonus) || 0;
        const chinaFee = Number(element.chinaDeliver) || 0;

        subtotal += price * qty;
        chinaDeliver += chinaFee * qty;

        if (discount > 0) {
          const discountedPrice = price * ((100 - discount) / 100);
          sale += (price - discountedPrice) * qty;
          bonus += (discountedPrice * (productBonus / 100)) * qty;
        } else {
          bonus += (price * (productBonus / 100)) * qty;
        }
      });

      if (subtotal * 0.02 > 50000) {
        fee = 50000;
      } else if (subtotal * 0.02 < 5000) {
        fee = 5000;
      } else {
        fee = Math.ceil((subtotal * 0.02) / 100) * 100;
      }

      this.syncExtraServiceAmounts();

      const couponAmount = this.coupon.active ? (Number(this.coupon.amount) || 0) : 0;
      const shippingAmount = this.deliver ? (Number(this.shipping.amount) || 0) : 0;
      const assembleAmount = Number(this.cart.assemble) || 0;
      const mowAmount = Number(this.cart.mow) || 0;

      const baseSum =
        subtotal -
        sale -
        couponAmount +
        fee +
        chinaDeliver +
        shippingAmount +
        assembleAmount +
        mowAmount;

      const noatAmount = this.NOAT ? Math.round(baseSum * 0.1) : 0;
      const finalSum = baseSum + noatAmount;

      this.cart.subtotal = subtotal;
      this.cart.sale = sale;
      this.cart.bonus = bonus;
      this.cart.chinaDeliver = chinaDeliver;
      this.cart.Fee = fee;
      this.cart.NOAT = noatAmount;
      this.cart.sum = finalSum;
    },

    changeQty() {
      localStorage.cart = JSON.stringify(this.cart.product);
      this.$emit("calcCart");
      this.calculate();
    },

    calcMaxQty(id) {
      let remain = 0;

      this.cart.real.forEach((element) => {
        if (element.id == id) {
          remain = element.remain;
        }
      });

      return remain;
    },

    submitForm() {
      const token = localStorage.getItem("token");
      const rts = this;

      this.calculate();

      if (!rts.deliver && rts.shipping.warehouse == 0) {
        rts.$notify({
          title: "Амжилтгүй",
          message: "Хүргэлт сонгох эсвэл очиж авах хаяг сонгоно уу",
          type: "error"
        });
        return;
      }

      const selectedProducts = this.getSelectedProducts();

      if (!selectedProducts.length) {
        rts.$notify({
          title: "Амжилтгүй",
          message: "Сонгосон бүтээгдэхүүн алга байна.",
          type: "error"
        });
        return;
      }

      const payloadCart = {
        ...this.cart,
        product: selectedProducts,
        assemble: this.deliver && this.assemble ? this.cart.assemble : 0,
        mow: this.deliver && this.mow ? this.cart.mow : 0,
        NOAT: this.NOAT ? this.cart.NOAT : 0,
        useBonus: this.useBonus ? this.cart.useBonus : 0
      };

      const payloadShipping = {
        ...this.shipping,
        amount: this.deliver ? this.shipping.amount : 0
      };

      const payloadCoupon = this.coupon.active
        ? { ...this.coupon }
        : {
            code: null,
            active: false,
            amount: 0,
            input: this.coupon.input
          };

      rts.$axios({
        method: "POST",
        url: rts.$appUrl + "/api/product/create-order",
        headers: {
          Authorization: `Bearer ${token}`
        },
        data: {
          shipping: payloadShipping,
          cart: payloadCart,
          deliver: this.deliver,
          coupon: payloadCoupon
        }
      }).then((data) => {
        if (data.data.result == "success") {
          rts.$router.push("/confirm-order/" + data.data.ordernumber);
        } else {
          rts.$notify({
            title: "Амжилтгүй",
            message: "Уучлаарай. Өөрийн имэйл хаягыг оруулна уу.",
            type: "error"
          });
        }
      });
    },

    getProduct() {
      this.shipping.w3w = localStorage.getItem("w3w");

      const coupon = JSON.parse(localStorage.getItem("coupon"));
      if (coupon != null) {
        this.coupon.code = coupon.code;
        this.coupon.amount = parseInt(coupon.amount);
      }

      const reg = localStorage.getItem("reg");
      if (reg != null) {
        this.shipping.user.register = reg;
      }

      let ids = [];
      let cart = JSON.parse(localStorage.getItem("cart"));

      if (!cart || !cart.length) {
        this.$router.push("/error-page");
        return;
      }

      cart = cart.map((el) => this.normalizeCartItem(el));

      this.cart.productCount = 0;

      cart.forEach((el) => {
        if (this.isItemSelectable(el)) {
          ids.push(`'${el.id}'`);
          this.cart.productCount += Number(el.qty) || 0;
        }
      });

      const token = localStorage.getItem("token");
      const rts = this;

      rts.$axios({
        method: "POST",
        url: rts.$appUrl + "/api/product/cart-shipping",
        headers: {
          Authorization: `Bearer ${token}`
        },
        data: {
          coupon: this.coupon.code,
          id: ids
        }
      }).then(function (data) {
        rts.shipping.user.name = data.data.address[0].name;
        rts.shipping.user.phone = data.data.address[0].phone;
        rts.shipping.user.phone2 = data.data.address[0].phone2;
        rts.shipping.user.email = data.data.address[0].email;
        rts.shipping.user.bonus = data.data.address[0].bonus;
        localStorage.bonus = rts.shipping.user.bonus;

        rts.cart.totalKg = data.data.kg;
        rts.cart.totalVol = data.data.vol;
        rts.cart.packCount = data.data.packs;

        if (data.data.address[0].district != 0 && data.data.address[0].district != null) {
          rts.shipping.user.district = data.data.address[0].district;

          if (data.data.address[0].khoroo == null || data.data.address[0].khoroo == 0) {
            rts.shipping.user.khoroo = 1;
          } else {
            rts.shipping.user.khoroo = data.data.address[0].khoroo;
          }

          rts.shipping.user.more = data.data.address[0].more_address;
        } else {
          rts.shipping.user.district = data.data.districts[0].id;
        }

        rts.range.district = data.data.districts;

        if (data.data.coupon == null) {
          rts.coupon.code = null;
          rts.coupon.amount = 0;
          rts.coupon.active = false;
        } else {
          rts.coupon.active = true;
          rts.coupon.amount = data.data.coupon[0].amount;
          localStorage.coupon = JSON.stringify({
            code: rts.coupon.code,
            amount: data.data.coupon[0].amount
          });
        }

        cart.forEach((el) => {
          data.data.price.forEach((p) => {
            if (el.id == p.code) {
              el.price = Number(p.price_tug) || 0;
              el.chinaDeliver = Number(p.china_deliver) || 0;
            }
          });
        });

        localStorage.cart = JSON.stringify(cart);
        localStorage.shipping = 0;

        rts.cart.product = cart;
        rts.calculate();
        rts.calculateShipping();
        rts.calculateBonusLimit();
      }).catch((error) => {
        console.log(error);
      });
    }
  }
};
</script>